export class NativeStreamBuiltinFunctionsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "functions",
            "baseName": "functions",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamBuiltinFunctionsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
